import { type ReactNode } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Admin } from './routes/Admin';
import { Attire } from './routes/Attire';
import { FAQ } from './routes/FAQ';
import { Games } from './routes/Games';
import { Home } from './routes/Home';
import { PasswordGate } from './routes/PasswordGate';
import { RSVP } from './routes/RSVP';
import { StyleGuide } from './routes/StyleGuide';
import { Travel } from './routes/Travel';
import { SessionProvider, useSession } from './lib/session';

export function App() {
  return (
    <SessionProvider>
      <Routes>
        {/* Unlisted, and deliberately outside <Gated> — /admin has its own
            separate password and does not ride on a guest session. */}
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<GatedSite />} />
      </Routes>
    </SessionProvider>
  );
}

function GatedSite() {
  return (
    <Gated>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schedule" element={<Page><Attire /></Page>} />
        <Route path="/travel" element={<Page><Travel /></Page>} />
        <Route path="/rsvp" element={<Page><RSVP /></Page>} />
        <Route path="/games" element={<Page><Games /></Page>} />
        <Route path="/faq" element={<Page><FAQ /></Page>} />
        <Route path="/styleguide" element={<Page><StyleGuide /></Page>} />
        <Route path="*" element={<Page title="Not found" />} />
      </Routes>
    </Gated>
  );
}

function Gated({ children }: { children: ReactNode }) {
  const { authenticated, loading } = useSession();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-pine/40">…</div>;
  }
  if (!authenticated) return <PasswordGate />;
  return <>{children}</>;
}

function Page({ title, children }: { title?: string; children?: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Header theme="light" />
      <main className="mx-auto w-full max-w-5xl flex-1 px-6 py-12">
        {title ? (
          <div className="py-12">
            <h1 className="font-serif text-5xl text-pine sm:text-6xl">{title}</h1>
            <p className="mt-4 font-sans text-lg font-normal tracking-[0.02em] text-pine">
              Coming soon.
            </p>
          </div>
        ) : (
          children
        )}
      </main>
      <Footer />
    </div>
  );
}
